/*
 * Runs a callback while the browser parses the page, at most once per frame in which it has
 * added a piece of it, and once more when the page is complete (DOMContentLoaded). The layout
 * scripts of the lists (EventgalleryImageList.js, EventgalleryTilesCollection.js) use it to lay
 * a list out as soon as its images are in the page, before the browser paints it, so the rows
 * of the stylesheet do not jump into the rows of the script on the screen. A mutation observer
 * delivers its records at the end of the task which added the nodes; the callback waits for the
 * next animation frame, which the browser runs before it paints, so all the pieces of one frame
 * are laid out together. Until the review of #1894 the callback ran for every piece: a list was
 * measured anew for each, which made the browser lay out the page parsed so far each time (12
 * passes for the image list of La Palma on a slow phone). The scripts of Event Gallery are loaded
 * in the head of the page; a script which runs after the page is parsed calls the callback once,
 * at once.
 *
 * @param {() => void} callback
 * @param {Document} [doc]
 */
export function whileParsing(callback, doc = document) {
    if (doc.readyState !== 'loading') {
        callback();
        return;
    }
    let observer = null;
    let frame = 0;
    if (typeof MutationObserver !== 'undefined') {
        observer = new MutationObserver(() => {
            if (!frame) {
                frame = window.requestAnimationFrame(() => {
                    frame = 0;
                    callback();
                });
            }
        });
        observer.observe(doc.documentElement, { childList: true, subtree: true });
    }
    doc.addEventListener('DOMContentLoaded', () => {
        if (observer) {
            observer.disconnect();
        }
        if (frame) {
            window.cancelAnimationFrame(frame);
            frame = 0;
        }
        callback();
    }, { once: true });
}
